import React from 'react';
import { useTranslation } from 'react-i18next';
import { stepsChecker } from 'utils/general';

import {
  FarmSetupCollapse,
  InventoryCollapse,
  WorkforceCollapse,
} from '@/modules/Onboarding';
import ProgressBar from '@/modules/settings/approvals/components/shared/ProgressBar';
import { useAuth } from '@/shared/hooks/context/auth';

import CheckedClipboard from '~/images/shared/MultiCheckedClipboard.svg';

const SetupGuide = () => {
  const { t } = useTranslation('onboarding');
  // TODO: move checks to store note auth
  const { onboardingChecks } = useAuth();

  const currentStep = stepsChecker(onboardingChecks);

  return (
    <div className='w-full rounded-2xl bg-background-neutral-99 py-16'>
      <div className='flex w-full items-center gap-16 border-b-xs border-b-neutralVariant-90 px-24 pb-16'>
        <span className='text-24 text-primary-default'>
          <CheckedClipboard />
        </span>
        <span className='text-18 font-semi-bold'>{t('setup-guide')}</span>
      </div>
      <div className='flex items-center gap-2 px-16 pt-16 pb-2'>
        <div className='w-full'>
          <ProgressBar step={currentStep} stepsNumber={8} />
        </div>
        <div className='flex items-center gap-[0.1rem] text-14'>
          <span>{currentStep}</span>
          <span>/</span>
          <span>8</span>
          <span>{t('completed')}</span>
        </div>
      </div>
      <div className='flex flex-col gap-2 px-16'>
        <FarmSetupCollapse />
        <div className='w-full border-b-xs border-b-neutralVariant-90' />
        <InventoryCollapse />
        <div className='w-full border-b-xs border-b-neutralVariant-90' />
        <WorkforceCollapse />
      </div>
    </div>
  );
};

export { SetupGuide };
